<script>
  import { reactive, watch } from 'vue'
  import {
    BeerInput as Input,
    InputWithUnit,
    InputWithOption,
    RangeInput,
    ComboInput,
    BeerTextArea as TextArea,
    RadioGroup,
    BeerCheckbox as Checkbox,
    BeerSwitch as Switch,
    SingleSelect,
    MultiSelect,
    CascadeSelect,
    MultiCascadeSelect,
    BeerSingleDatePicker as SingleDatePicker,
    BeerMultiDatePicker as MultiDatePicker,
    BeerDateRangePicker as DateRangePicker,
    BeerClockSelect as ClockSelect,
    BeerFileUploader as FileUploader,
    ImageUploader,
  } from '@xhs/yam-beer'
  import { FormBase } from '@xhs/vue-formily'

  import FormItem from './FormItem'

  import SubmitButton from './SubmitButton'
  import ResetButton from './ResetButton'

  function getMergeUpdateCmp(Cmp, keys) {
    return {
      props: {
        modelValue: {},
      },
      emits: ['update:modelValue'],
      setup(props, { attrs, emit }) {
        const val = reactive(props.modelValue || {})

        watch(val, newV => {
          emit('update:modelValue', newV)
        })

        watch(() => props.modelValue, model => {
          Object.keys(model).forEach(k => {
            val[k] = model[k]
          })
        })
        const onUpdate = keys.reduce((acc, k) => {
          acc[`onUpdate:${k}`] = v => {
            val[k] = v
          }
          return acc
        }, {})

        return () => {
          const values = keys.reduce((acc, k) => {
            acc[k] = val[k]
            return acc
          }, {})
          const mergedProps = {
            ...attrs,
            ...values,
            ...onUpdate,
          }
          return <Cmp {...mergedProps} />
        }
      },
    }
  }

  const components = {
    Input,
    InputWithUnit: getMergeUpdateCmp(InputWithUnit, ['left', 'right', 'modelValue']),
    InputWithOption,
    RangeInput: getMergeUpdateCmp(RangeInput, ['left', 'right', 'unit']),
    ComboInput,
    TextArea,
    RadioGroup,
    Checkbox,
    Switch,
    SingleSelect,
    MultiSelect,
    CascadeSelect,
    MultiCascadeSelect,
    SingleDatePicker,
    MultiDatePicker,
    DateRangePicker: getMergeUpdateCmp(DateRangePicker, ['start', 'end']),
    ClockSelect,
    ImageUploader,
    FileUploader,
  }

  const formItems = {
    FormItem,
  }

  export default {
    name: 'BeerForm',

    components: {
      SubmitButton,
      ResetButton,
    },

    extends: FormBase,

    computed: {
      mergedComponents() {
        return {
          ...components,
          ...this.components,
        }
      },

      mergedFormItems() {
        return {
          ...formItems,
          ...this.formItems,
        }
      },
    },
  }
</script>
